import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  eeClassContentWrapper: {
    backgroundColor: colors.neutral.white,
    padding: '4rem 9rem',
    borderRadius: '1rem',
    position: 'relative',
    minHeight: '50rem',
    overflow: 'hidden',
    marginBottom: '6rem',
  },
  createClassTitle: {
    fontSize: '2.4rem',
    lineHeight: '3.2rem',
    marginBottom: '0.5rem',
    fontWeight: '700',
    letterSpacing: '2%',
    textAlign: 'center',
  },
  createClassSubtitle: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    color: colors.neutral[700],
    marginBottom: '1rem',
    marginTop: 0,
    textAlign: 'center',
  },
  eeGuideline: {
    margin: '0 auto',
    '& button:first-child': {
      fontSize: '1.6rem',
      margin: '0 auto',
    },
  },
  addClassBtn: {
    textTransform: 'uppercase',
    marginTop: '2.5rem',
    paddingLeft: 0,
    marginBottom: '3rem',
    fontWeight: 700,
  },
  classTypeBlock: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(366px, 1fr))',
    columnGap: '5rem',
    '@media(max-width: 1000)': {
      gridTemplateColumns: '1fr',
      columnGap: 0,
    },
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    '& button:first-child': {
      marginRight: '2rem',
    },
  },
  typeSections: {
    marginBottom: '8rem',
    marginTop: '3rem',
  },
  section: {
    '&:not(:first-child)': { marginTop: '3rem' },
    '&:not(:last-child)': { borderBottom: `0.1rem solid ${colors.neutral[400]}` },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
